import { createContext, useState, useEffect } from "react";
import Cookies from "js-cookie";



export const FilterContext = createContext();

export const FilterProvider = ({ children }) => {

    const [filters, setFilters] = useState({});
    // const [routeFilters, setRouteFilters] = useState({});

    // const updateRoutesFilters = (path, newFilter) => {
    //     setRouteFilters((prev) => ({
    //         ...prev,
    //         [path]: newFilter,
    //     }));
    // };

    // const getCurrentFilters = (path) => {
    //     return routeFilters[path] || {};
    // };

    return (
        <FilterContext.Provider
            value={{
                filters,
                setFilters,
                // routeFilters,
                // setRouteFilters,
                // updateRoutesFilters,
                // getCurrentFilters,
            }}
        >
            {children}
        </FilterContext.Provider>
    );
};

export default FilterContext;
